
import React, { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import MainRoutes from "./main-routes";
import NotFound from "../pages/404";
import Rating from "../pages/rating";

// Lazy load all auth and waitlist pages
const Login = lazy(() => import("../pages/auth/login"));
const ReadyToGo = lazy(() => import("../pages/auth/ready-to-go"));
const SignUpWaitList = lazy(() => import("../pages/waitlist-dashboard/waitlist/signup"));
const VerifyWhatsappNumber = lazy(() => import("../pages/waitlist-dashboard/waitlist/verify"));
const WhatsappCheck = lazy(() => import("../pages/waitlist-dashboard/waitlist/check"));
const ForgotPassword = lazy(() => import("../pages/auth/forgot-password"));
const ResetPassword = lazy(() => import("../pages/auth/reset-password"));
const VerifyEmail = lazy(() => import("../pages/waitlist-dashboard/waitlist/verify-email"));
const CheckComplete = lazy(() => import("../pages/waitlist-dashboard/waitlist/complete-check"));
const JoinWaitlist = lazy(() => import("../pages/waitlist-dashboard/waitlist/reg-phone"));
const AccessMainApp = lazy(() => import("../pages/waitlist-dashboard/waitlist/access-app"));
const SetUp = lazy(() => import("../pages/auth/set-up"));
const AdvertiserMultiStepSignup = lazy(() => import("../pages/auth/advertiser-signup"));
const SignUp = lazy(() => import("../pages/auth/signup"));
const SignInFromWaitlist = lazy(() => import("../pages/auth/signin-waitlist"));
const VerifySignUp = lazy(() => import("../pages/auth/verify"));
const SignupCheck = lazy(() => import("../pages/auth/check"));
const SignupVerifyMail = lazy(() => import("../pages/auth/verify-email"));
const SignUpFinalCheck = lazy(() => import("../pages/auth/final-check"));
const EditVerifyEmail = lazy(() => import("../pages/auth/verify-edit-email"));


const PageLoader = () => (
  <div className="flex justify-center items-center min-h-screen bg-white">
    <div className="flex flex-col items-center gap-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00A86B]"></div>
      <p className="text-sm text-gray-500">Loading...</p>
    </div>
  </div>
);

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader />}>{children}</Suspense>
);

export default function ThemeRoutes() {
  const READY_MODE = true;

  return useRoutes([
    ...MainRoutes,
    { 
      path: "/login-waitlist", 
      element: <Navigate to="/login" replace /> 
    },
    { 
      path: "/join/waitlist", 
      element: <Navigate to="/signup" replace /> 
    },
    // Also handle the case with referral code
    { 
      path: "/join/waitlist/:referralCode", 
      element: <Navigate to="/signup" replace /> 
    },
{ 
      path: "/login", 
      element: (
        <SuspenseWrapper>
          <Login />
        </SuspenseWrapper>
      ) 
    },
    // {
    //   path: "/login",
    //   element: READY_MODE ? (
    //     <Navigate to="/ready" replace />
    //   ) : (
    //     <Login />
    //   ),
    // },
    { 
      path: "/ready", 
      element: (
        <SuspenseWrapper>
          <ReadyToGo />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/join/waitlist/:referralCode?", 
      element: (
        <SuspenseWrapper>
          <SignUpWaitList />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/verify", 
      element: (
        <SuspenseWrapper>
          <VerifyWhatsappNumber />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/check", 
      element: (
        <SuspenseWrapper>
          <WhatsappCheck />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/forgotpassword", 
      element: (
        <SuspenseWrapper>
          <ForgotPassword />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/resetpassword", 
      element: (
        <SuspenseWrapper>
          <ResetPassword />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/verify-email", 
      element: (
        <SuspenseWrapper>
          <VerifyEmail />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/check/complete", 
      element: (
        <SuspenseWrapper>
          <CheckComplete />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/login-waitlist", 
      element: (
        <SuspenseWrapper>
          <JoinWaitlist />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/access/main", 
      element: (
        <SuspenseWrapper>
          <AccessMainApp />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/setup", 
      element: (
        <SuspenseWrapper>
          <SetUp />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/advertiser/signup", 
      element: (
        <SuspenseWrapper>
          <AdvertiserMultiStepSignup />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/signup/:referralCode?", 
      element: (
        <SuspenseWrapper>
          <SignUp />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/onboarding", 
      element: (
        <SuspenseWrapper>
          <SignInFromWaitlist />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/signup/verify", 
      element: (
        <SuspenseWrapper>
          <VerifySignUp />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/signup/check", 
      element: (
        <SuspenseWrapper>
          <SignupCheck />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/signup/verify-email/:token?", 
      element: (
        <SuspenseWrapper>
          <SignupVerifyMail />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/signup/final/check/:token?", 
      element: (
        <SuspenseWrapper>
          <SignUpFinalCheck />
        </SuspenseWrapper>
      ) 
    },
    { 
      path: "/update/email", 
      element: (
        <SuspenseWrapper>
          <EditVerifyEmail />
        </SuspenseWrapper>
      ) 
    },

     { 
      path: "/rate/:link_id?", 
      element: (
        <SuspenseWrapper>
          <Rating />
        </SuspenseWrapper>
      ) 
    },

   

    // 404
    { 
      path: "*", 
      element: (
        <SuspenseWrapper>
          <NotFound />
        </SuspenseWrapper>
      ) 
    },
  ]);
}
